<div class="border flex flex-col lg:flex-row">
  <!-- Main Canvas Area -->
  <div class="w-full lg:w-[70%] border-2 example-boundary overflow-hidden relative" id="canvas-container"
    #canvasContainer>
    <!--ASSET Canvas Items -->
    <div class="" *ngIf="!isPowerTrain">
      <div *ngFor="let item of canvasItems" cdkDrag cdkDragBoundary=".example-boundary"
        (cdkDragEnded)="onDragEnd($event, item)" class="absolute cursor-move border" [ngStyle]="{
          width: item.widthPercent + '%'
        }" [ngClass]="{
          'border-4 border-red-500': selectedAsset.id == item.id
        }" id="asset-{{ item.id }}" (click)="onCanvasItemClick(item)">
        <img [src]="item.src" class="w-full h-full" />

        <!-- Sensors -->
        <div *ngFor="let sensor of item.sensors" cdkDrag cdkDragBoundary="#asset-{{ item.id }}"
          (cdkDragEnded)="onSensorDragEnd($event, sensor)"
          class="absolute border rounded-lg bg-white flex items-center justify-center cursor-move" [ngStyle]="{
            width: '50px',
            height: '30px',
            fontSize:'10px'
          }">
          {{ sensor.id === 0 ? "B" : sensor.id }}
        </div>
      </div>
    </div>

    <!-- POWERTRAIN CANVAS ITEMS -->
    <div class="mb-4 w-100 h-100" *ngIf="isPowerTrain">
      <div class="cursor-move border" *ngFor="let item of powertrainCanvasItems" [ngStyle]="{
          top: '0px',
          left: '0px',
          width: '100%',
          height: '100%'
        }" [ngClass]="{
          'border-4 border-red-500': selectedAsset.id == item.id
        }" id="asset-{{ item.id }}" (click)="onCanvasItemClick(item)">
        <!-- Place .img here for the image -->
        <img [src]="item.image_path" class="w-full h-full img" />

        <!-- Sensors -->
        <div *ngFor="let sensor of item.sensors; let i = index" (click)="onPowertrainSensorClick(item, i)" cdkDrag
          cdkDragBoundary="#asset-{{ item.id }}" (cdkDragEnded)="onPowertrainSensorDragEnd($event, sensor)"
          class="absolute border rounded-lg bg-white flex items-center justify-center" [ngStyle]="{
            top: '0px',
            left: '0px',
            width: '40px',
            height: '30px'
          }">
          <!-- {{ sensor.sensor_number === 0 ? "B" : sensor.sensor_number }} -->
          {{ sensor.sensorMarker }}
        </div>
      </div>
    </div>
  </div>

  <div class="container" style="height: 100%;">
    <!-- OLD  BUTTONS -->
    <!-- <div class="row">
      <button class="btn btn-primary" (click)="selectPowerTrainType(false)">
        Assets
      </button>
      <button class="btn btn-secondary" (click)="selectPowerTrainType(true)">
        Powertrains
      </button>
      <button
        *ngIf="isPowerTrain"
        class="btn btn-success"
        (click)="addPowerTrainSensor()"
      >
        Add Sensor
      </button>
      <button
        *ngIf="isPowerTrain"
        class="btn btn-danger"
        (click)="openPowertrainNameModalBox()"
      >
        Save Template
      </button>
      <button
        *ngIf="powertrainSelectedSensor.assetType && isPowerTrain"
        class="btn btn-warning"
        (click)="deleteCurrentPowertrainSensor()"
      >
        Delete current sensor
      </button>
      <button class="btn btn-info" (click)="deleteCanvasSensor()">
        Delete Sensors
      </button>
      <button *ngIf="!isPowerTrain" class="btn btn-light" (click)="addSensor()">
        Add Sensor
      </button>
      <button
        *ngIf="!isPowerTrain"
        class="btn btn-dark"
        (click)="openPowertrainNameModalBox()"
      >
        Save Template
      </button>
    </div> -->
    <!-- NEW  BUTTONS -->
    <div class="button-section xScale_button_container">
      <h2>Powertrains</h2>
      <div class="buttons">
        <!-- Add Sensor Button -->
        <button mat-stroked-button class="" (click)="uploadImage()">
          <i class="fas fa-plus"></i>
          Upload Images
        </button>
        <button mat-stroked-button class="" (click)="addPowerTrainSensor()">
          <i class="fas fa-plus"></i>
          Add Sensor
        </button>
        <!-- Save Template Button -->
        <button mat-stroked-button class="" (click)="openPowertrainNameModalBox()">
          <i class="fas fa-save"></i>
          Save Template
        </button>
        <!-- Delete Sensors Button -->
        <button mat-stroked-button class="" (click)="deleteCanvasSensor()">
          <i class="fas fa-trash"></i>
          Delete Sensors
        </button>
      </div>
    </div>
    <!-- Sidebar -->
    <!-- ROTATING ASSET OLD DISABLED FOR NOW -->
    <div *ngIf="!isPowerTrain" class="row w-full lg:w-[30%] border-2 p-4 space-y-4">
      <div class="grid grid-cols-2 gap-4">
        <img *ngFor="let image of images" [src]="image.src" [alt]="image.alt" (click)="addImageToCanvas(image)"
          class="w-20 h-20 cursor-pointer hover:shadow-md" />
      </div>
    </div>
    <!-- POWERTRAIN IMAGES LOADER -->
    <div *ngIf="isPowerTrain && powertrainImageLoader" class="row w-full lg:w-[30%] border-2 p-4 space-y-4">
      <div class="grid grid-cols-2 gap-4" style="height: 30vh; overflow: scroll; width: 100%">
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
      </div>
    </div>
    <!-- POWERTRAIN IMAGES -->
    <div *ngIf="isPowerTrain && !powertrainImageLoader" class="row w-full lg:w-[30%] border-2 p-4 space-y-4" style="height: 600px; overflow: scroll;">
      <div class="grid grid-cols-2 gap-4">
        <img *ngFor="let image of powerTrainImages" [src]="image.image_path" [alt]="image.image_alt"
          (click)="addImageToPowerTrainCanvas(image)" class="cursor-pointer hover:shadow-md" style="width: 100%" />
      </div>
    </div>

    <div class="asset-details-card">
      <div class="detail-row">
        <span class="detail-label">Asset Type</span>
        <span class="detail-value">{{ powertrainSelectedSensor.assetType }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Sub Type</span>
        <span class="detail-value">{{ powertrainSelectedSensor.subType }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Asset Marker</span>
        <span class="detail-value highlight">{{ powertrainSelectedSensor.assetMarker }}</span>
      </div>
    </div>

  </div>
</div>
<br /><br />
<!-- <div
  class="selectedAsset"
  style="width: 50%"
  *ngIf="selectedAsset.asset_type && !isPowerTrain"
>
  <span class="">Asset Type:{{ selectedAsset.asset_type }}</span>
  <span class="">Sub Type:{{ selectedAsset.sub_type }}</span>
  <span class="">Asset Marker:{{ selectedAsset.asset_marker }}</span>
</div>
<div
  class="selectedAsset"
  style="width: 50%"
  *ngIf="powertrainSelectedSensor.assetType && isPowerTrain"
>
  <span class="">Asset Type:{{ powertrainSelectedSensor.assetType }}</span>
  <span class="">Sub Type:{{ powertrainSelectedSensor.subType }}</span>
  <span class="">Asset Marker:{{ powertrainSelectedSensor.assetMarker }}</span>
</div> -->




<app-powertrain-modal [type]="'motor_selection'" [data]="{}" *ngIf="openModal"
  (closeBox)="closeBox($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'asset_selection'" [data]="{ isMaster: powerTrainSensorsNumber }"
  *ngIf="openPowertrainSensorModal" (closeBox)="closePowerTrainSensorBox($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'powertrain_name'" *ngIf="openPowertrainNameModal"
  (closeBox)="inputPowertrainName($event)"></app-powertrain-modal>

<app-file-upload-modal *ngIf="isUploadModalOpen" [isOpen]="isUploadModalOpen" (closeModal)="closeUploadModal()"
  (uploadSuccess)="onUploadSuccess($event)" />